import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isStandalone, consumeDeepLink } from '../utils/deepLink';

// On the FIRST standalone launch (PWA opened at its start_url '/'), if the user
// had recently viewed a shareable item before installing, send them straight to
// that item. Runs once on mount; no-op in a normal browser tab.
const DeepLinkRedirector = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isStandalone()) return;
    if (location.pathname !== '/') return; // only the launch landing
    const target = consumeDeepLink();
    if (target && target !== '/' && target.startsWith('/')) {
      navigate(target, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default DeepLinkRedirector;
